import React from "react";
import { Icon, List } from "semantic-ui-react";
import PersonName from "../PersonName";
import { usePerson } from "../../../data/persons/usePerson";
import { CompanyNameById } from "../../companies/CompanyName";
import { IPerson } from "../../../models/IPerson";
import { TCertValidationFn } from "../../../hooks/usePersonCertValidator";
import { PersonCertStatus } from "../PersonCertStatus";
import "./_PersonSearch.less";
import { NotifyByIcon } from "./NotifyByIcon";


interface PersonSearchListItemProps {
    personId: number;
    onUnselect?: (id: number) => void;
    onEditPerson?: (id: IPerson) => void;
    certValidator: TCertValidationFn;
};

export const PersonSearchListItem: React.FC<PersonSearchListItemProps> = ({
    personId,
    onUnselect,
    onEditPerson,
    certValidator
}) => {
    // const t = useTranslation().t;
    /*
        const texts = {
            notificationsByPhone: t("Ilmoitukset lähetetään tekstiviestillä"),
            notificationsByEmail: t("Ilmoitukset lähetetään sähköpostilla"),
            unableToSendNotifications: t("Käyttäjälle ei voida lähettää ilmoituksia"),
        };
    */
    const { data: person } = usePerson(personId);

    if (!person) {
        return null
    };

    const certStatus = certValidator(person.certs)
    const notifyBy = person.phone?.length ? "phone" : person.email?.length ? "mail" : "none";

    return (
        <List.Item key={personId} >
            <div className="PersonSearch-item-content">
                <div className="PersonSearch-item-fullname notranslate">
                    {certStatus ? (
                        <PersonCertStatus status={certStatus} />
                    ) : null}

                    <NotifyByIcon notifyBy={notifyBy} />

                    <div className="PersonSearch-item-name-and-company">
                        <PersonName person={person} infoPopup />
                        {person.company && (
                            <CompanyNameById
                                className="PersonSearch-item-company"
                                companyId={person.company}
                            />
                        )}
                    </div>
                </div>


                <div style={{ justifySelf: "flex-end" }}>
                    <span className="item-icon action" onClick={() => onEditPerson && onEditPerson(person)}>
                        <Icon name="edit" />
                    </span>
                    <span className="item-icon action" onClick={() => onUnselect && onUnselect(person.id)}>
                        <Icon name="times" />
                    </span>
                </div>

            </div>
        </List.Item>
    )
};
